import { ActionType, AppLanguage } from '@core-lib/enums';
import { IAppConfig, IConfirmModalConfig, INatureAffairePieceJointe, IReferentials, ITiersWithAdress } from '@core-lib/models';
import { AutocompleteControlData } from '@core-lib/models/autocomplete.model';
import { createActionWithSingleProps } from '@core-lib/store/action-creators.function';
import { CorrelationParams } from '@core-lib/store/correlated-actions.model';
import { createEntityActions, createEntityActionsBy } from '@core-lib/store/entity-slice.function';
import { Action, createAction, props } from '@ngrx/store';
import { ModalRef, IModalOptions } from '@core-lib/modules/modal-container';
import { NavigationExtras } from '@angular/router';

const ActionPrefix = 'Common';

export const Noop = createAction(`[${ActionPrefix}] Noop`);

export const InitLanguages = createAction(`[${ActionPrefix}] Init Languages`);
export const SetLanguage = createActionWithSingleProps<AppLanguage>(`[${ActionPrefix}] Language`);

export const ReferentialsActions = createEntityActionsBy<IReferentials, boolean>(ActionPrefix, 'Referentials');

export const {
	UpdateEntityRequest: LoadReferentialsRequest,
	LoadEntityMergeSuccess: LoadReferentialsSuccess,
	LoadEntityFailure: LoadReferentialsFailure
} = ReferentialsActions;

export const AddToControlAutocomplete = createActionWithSingleProps<AutocompleteControlData>(`${ActionPrefix} Add AutocompleteData`);
export const AddToControlAutocompleteSuccess = createActionWithSingleProps<AutocompleteControlData>(
	`${ActionPrefix} Add AutocompleteData Success`
);

export const Navigate = createAction(
  `[${ActionPrefix}] Navigate To`,
  props<{
    param: any[];
    extras?: NavigationExtras;
  }>()
);


export const BalanceEcarts = createAction(
	`[${ActionPrefix}] Balance Ecarts`,
	(entity: any, successAction?: Action, correlationParams?: CorrelationParams) => ({
		entity,
		successAction,
		correlationParams
	})
);

export const OpenConfirmationModal = createAction(
	`[${ActionPrefix}] Open Confirm Modal`,
	(
		config: IConfirmModalConfig,
		confirmationAction?: Action | Action[],
		cancelAction?: Action | Action[],
		correlationParams?: CorrelationParams
	) => ({
		config,
		confirmationAction,
		cancelAction,
		correlationParams,
		modalOptions: <IModalOptions>{ ...config.modalOptions, class: 'modal-lg' }
	})
);

export const OpenCancelConfirmationModal = createAction(
	`[${ActionPrefix}] Open Cancel Confirm Modal`,
	(
		config: IConfirmModalConfig,
		confirmationAction?: Action[],
		cancelAction?: Action | Action[],
		correlationParams?: CorrelationParams
	) => ({
		config,
		confirmationAction,
		cancelAction,
		correlationParams,
		modalOptions: <IModalOptions>{ ...config.modalOptions, class: 'modal-lg' }
	})
);

export const SetConfirmationModal = createActionWithSingleProps<ModalRef['id']>(`[${ActionPrefix}] Set Confirm Modal`);
export const SetCancelConfirmationModal = createActionWithSingleProps<ModalRef['id']>(`[${ActionPrefix}] Set Cancel Confirm Modal`);

export const ResetAutocompleteData = createActionWithSingleProps<string[]>(`[${ActionPrefix}] Reset Autocomplete Data`);

export const ResetAutocompleteAddedTiers = createAction(`[${ActionPrefix}] Reset Autocomplete added tiers`);

export const CloseConfirmationModal = createAction(
	`[${ActionPrefix}] Close Confirm Modal`,
	props<{ actionType: ActionType; correlationParams?: CorrelationParams }>()
);

export const CloseCancelConfirmationModal = createAction(
	`[${ActionPrefix}] Close Cancel Confirm Modal`,
	props<{ actionType: ActionType; nextAction?: Action[]; correlationParams?: CorrelationParams }>()
);

export const TypesDocumentsActions = createEntityActions<INatureAffairePieceJointe[]>(ActionPrefix, 'Types Documents');
export const {
	LoadEntityRequest: LoadTypesDocumentsRequest,
	LoadEntitySuccess: LoadTypesDocumentsSuccess,
	LoadEntityFailure: LoadTypesDocumentsFailure
} = TypesDocumentsActions;

export const ConfigActions = createEntityActions<IAppConfig>(ActionPrefix, 'Config');
export const {
	LoadEntityRequest: LoadConfigRequest,
	LoadEntitySuccess: LoadConfigSuccess,
	LoadEntityFailure: LoadConfigFailure
} = ConfigActions;

// Error handling
export const HandleErrorException = createAction(
	`[${ActionPrefix}] Handle Error Exception`,
	props<{
		error: Error;
		errorCode: string;
		typeAction?: string;
		failureAction?: Action[];
		cancelAction?: Action;
	}>()
);

// frontoffice
export const HandleErrorExceptionAffaireFormFrontOffice = createAction(
	`[${ActionPrefix}] Handle Error Exception`,
	props<{
		error: Error;
		errorCode: string;
		typeAction?: string;
		failureAction?: string;
		affaireId?: string;
		navigateToBordereau?: boolean;
		navigateToRib?: boolean;
	}>()
);


